module.exports = __webpack_public_path__ + "static/home-4-1-ded2a10eda3729e95ca65aa5384b91f3.png";